<div class="document-viewer-container">
  @if (!isLoading && !loadError) {
    <div class="document-actions">
      <button nz-button nzType="default" (click)="openInNewTab()">
        <span nz-icon nzType="export" nzTheme="outline"></span>
        Open in New Tab
      </button>
    </div>
  }

  @if (isLoading) {
    <div class="loading-container">
      <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      <p>Loading document...</p>
    </div>
  }

  @if (loadError) {
    <div class="error-container">
      <span nz-icon nzType="file-exclamation" nzTheme="outline" style="font-size: 48px; color: #ff4d4f;"></span>
      <p>Failed to load document</p>
      <button nz-button nzType="primary" (click)="openInNewTab()">
        Open in New Tab
      </button>
    </div>
  }

  @if (!loadError) {
    <iframe
      [src]="safeDocumentUrl"
      class="document-iframe"
      (load)="onIframeLoad()"
      (error)="onIframeError()"
      frameborder="0"
    ></iframe>
  }
</div>

